import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Constant } from './../environments/constants';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  
  { 
    path: Constant.routes.home,
    canActivate: [MsalGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule) 
  },
  { 
    path: Constant.routes.plan,
    canActivate: [MsalGuard],
    loadChildren: () => import('./plan/plan.module').then(m => m.PlanModule) 
  },
  { 
    path: Constant.routes.poc,
    canActivate: [MsalGuard],
    loadChildren: () => import('./poc/poc.module').then(m => m.PocModule) 
  },  
  {
    path: 'id_token',
    //canActivate: [MsalGuard],
    redirectTo: Constant.routes.home,
    pathMatch: 'full'
  },
  {
    path: 'access_token',
    //canActivate: [MsalGuard],
    redirectTo: Constant.routes.home,
    pathMatch: 'full'
  },
  //This is for re-direct url. It should not have MsalGuard
  {
    path: 'signin-oidc',
    //canActivate: [MsalGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: '',    
    redirectTo: Constant.routes.home,
    pathMatch: 'full'
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
